import { render, staticRenderFns } from "./YoutubeConnect.vue?vue&type=template&id=45c2995e&scoped=true"
import script from "./YoutubeConnect.vue?vue&type=script&lang=js"
export * from "./YoutubeConnect.vue?vue&type=script&lang=js"
import style0 from "./YoutubeConnect.vue?vue&type=style&index=0&id=45c2995e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2995e",
  null
  
)

export default component.exports